// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__J9OnW","wrapper":"Dropdown_wrapper__RRBFA","tooltip":"Dropdown_tooltip__L7BEm"};